import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks"
import { getFilingSupportingDocs } from "../../../../features/state/StateFiling-slice";
import { APISettings } from "../../../../config/ApiSettings";
import saveAs from "file-saver";


export const useFileTabController = (filingId: number) => {
  const filingSupportingDocs = useAppSelector((state) => state.filings.filingSupportingDocs);
  const filingHearingDocs = useAppSelector((state) => state.filings.filingHearingDocs);
  const filingAffidavitDocs = useAppSelector((state) => state.filings.filingAffidavitDocs);
  const filingSummaryDocs = useAppSelector((state) => state.filings.filingSummaryDocs);
  const filingFiscalDocs = useAppSelector((state) => state.filings.filingFiscalDocs);
  const filingExplanatoryDocs = useAppSelector((state) => state.filings.filingExplanatoryDocs);
  const filingGPRODocs = useAppSelector((state) => state.filings.filingGPRODocs);
  const filingCoverLetterDocs = useAppSelector((state) => state.filings.filingCoverLetterDocs);
  const filingCertificateOfAdoptionDocs = useAppSelector((state) => state.filings.filingCertificateOfAdoptionDocs);

  const dispatch = useAppDispatch();

  useEffect(() => {
    getFiles();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getFiles = () => {
    dispatch(getFilingSupportingDocs(filingId));
  }

  const baseUrl = new APISettings().getApiURL();

  const downloadPdf = async (containerName: string, blobName: string, titleId?: number) => {
    let url = `${baseUrl}/fileStorage/GetAsByteArray/${containerName}/${blobName}`;
    let blob: Blob = await fetch(url).then((r) => r.blob());

    saveAs(blob, blobName);
  }

  return {
    filingSupportingDocs,
    filingHearingDocs,
    filingAffidavitDocs,
    filingSummaryDocs,
    filingFiscalDocs,
    filingExplanatoryDocs,
    filingGPRODocs,
    filingCoverLetterDocs,
    filingCertificateOfAdoptionDocs,
    downloadPdf,
  };
}